<template>
    <div class="col-xs-9">
        <div class="row row-space-between">
            <div class="col-size-auto">
                <h1 class="pagetitle">
                    {{ title }}
                </h1>
            </div>
        </div>
        <!-- TODO - make unique keys for for-loop -->
        <stock-list-model-overview-table v-for="(table, index) in tableData" :key="table.brand" :table-data="table" :term-texts="termTexts" :table-texts="tableTexts"></stock-list-model-overview-table>
    </div>
</template>

<script>
    import _ from 'qs';
    import StockListModelOverviewTable from './StockListModelOverviewTable.vue';
    export default {
        name: 'stocklist-model-overview-table-container',
        props: {
            title: {
                type: String,
                default: ""
            },
            termTexts: {
                type: Object,
                default: undefined
            },
            tableData: {
                type: Array,
                default: undefined
            },
            tableTexts: {
                type: Object,
                default: undefined
            },
        },
        components: {
            StockListModelOverviewTable
        }
    }
</script>